export default __webpack_public_path__ + "static/media/aae_client.152f475f.png";